// extracted by mini-css-extract-plugin
export default {"channelsPanel":"CCitv","channels":"_23WYF","channel":"GY24F","selected":"rCLAc","selectedChannelBackground":"XSdIS"};